import { useState } from 'react'
import dynamic from 'next/dynamic'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import CTA from 'components/CTA'
import { CM_TIMELINE_VIEW_I18N_NAMESPACE } from 'experiments/pen-5613_v1_cm_innovative_swing/i18n'
import { trackTrailerActionClicked } from '../../events'

const VideoModal = dynamic(() => import('components/VideoModal'), {
  ssr: false,
})

export interface TrailerProps {
  brightcoveVideoId?: string | null
  mediaUuid?: string | null
  instructorName?: string | null
  headline?: string | null
  id?: string | number | null
  slug?: string | null
  title?: string | null
  instructorAvatar?: string | null
}

export const TrailerAction = ({ trailer }: { trailer: TrailerProps }) => {
  const { t } = useTranslation(CM_TIMELINE_VIEW_I18N_NAMESPACE)
  const [isOpenTrailer, setIsOpenTrailer] = useState(false)

  if (!trailer.mediaUuid) return null

  const handleClick = () => {
    trackTrailerActionClicked({ slug: trailer.slug || '' })
    setIsOpenTrailer(true)
  }

  const videoModalProps = {
    show: isOpenTrailer,
    onCloseModal: () => setIsOpenTrailer(false),
    mediaUuid: trailer.mediaUuid || '',
    author: trailer.instructorName,
    tagline: trailer.headline,
    contentId: `${trailer.id}_${trailer.mediaUuid}`,
    contentTitle: trailer.title || '',
    contentType: TRACK_CONTENT_TYPES.COURSE_TRAILER,
    courseId: trailer.id || 0,
    instructorAvatar: trailer.instructorAvatar,
    buttonGroup: (
      <CTA
        trackProps={{
          category: 'need-to-know',
          class: trailer.slug,
          content_type: 'product',
          location: 'hero_trailer_modal',
          page_category: 'personalization',
        }}
      />
    ),
  }

  return (
    <>
      <Button
        kind='link'
        className='d-inline-flex flex-column mc-text--underline mc-p-0'
        onClick={handleClick}
        style={{ fontSize: '14px' }}
      >
        {t('variant_2.hero.watchTrailer')}
      </Button>

      {isOpenTrailer && <VideoModal {...videoModalProps} />}
    </>
  )
}
